export default __webpack_public_path__ + "static/media/icon.f1eefbd0.svg";